export const version = "address/5.5.0";
//# sourceMappingURL=_version.js.map